const DEFAULT_AUDIO_SETTINGS = {
  allSoundsEnabled: true,
  musicEnabled: true,
  characterSoundsEnabled: true,
};

export { DEFAULT_AUDIO_SETTINGS };

let audioSettingsState = { ...DEFAULT_AUDIO_SETTINGS };
const listeners = new Set();

export function getAudioSettings() {
  return { ...audioSettingsState };
}

export function setAudioSettings(next) {
  audioSettingsState = {
    ...DEFAULT_AUDIO_SETTINGS,
    ...next,
  };
  listeners.forEach((fn) => fn(audioSettingsState));
}

export function subscribeAudioSettings(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function canPlayMusic(settings = audioSettingsState) {
  return settings.allSoundsEnabled && settings.musicEnabled;
}

export function canPlayUiSfx(settings = audioSettingsState) {
  return settings.allSoundsEnabled;
}

export function canPlayCharacterSfx(settings = audioSettingsState) {
  return settings.allSoundsEnabled && settings.characterSoundsEnabled;
}

export function playSfxFile(path, volume = 0.7, category = 'ui') {
  if (!path) return;
  const settings = audioSettingsState;
  const allowed = category === 'character'
    ? canPlayCharacterSfx(settings)
    : category === 'music'
      ? canPlayMusic(settings)
      : canPlayUiSfx(settings);
  if (!allowed) return;

  const url = path.startsWith('/') ? path : `/${path}`;
  const vol = Math.min(1, Math.max(0, volume));
  if (category === 'ui') {
    playUiSfx(url, vol);
    return;
  }
  try {
    const audio = new Audio(url);
    audio.volume = vol;
    audio.play().catch(() => {});
  } catch (_) {
    // ignore
  }
}

// Arayüz sesleri: her dosya için tek, önceden yüklenmiş ses nesnesi. Aynı ses tekrar
// istenirse baştan çalar (üst üste binmez); çok kısa aralıklı tekrarlar yutulur.
// Yeni bir arayüz sesi başlarken çalan diğer arayüz sesi susturulur. Mobil tarayıcılarda
// her tıklamada yeni Audio oluşturmak gecikme ve birikme yapıyordu.
const UI_MIN_GAP_MS = 70;
const uiPool = new Map();
let uiCurrent = null;

function uiAudio(url) {
  let entry = uiPool.get(url);
  if (!entry) {
    const audio = new Audio(url);
    audio.preload = 'auto';
    entry = { audio, last: 0 };
    uiPool.set(url, entry);
  }
  return entry;
}

function playUiSfx(url, volume) {
  try {
    const entry = uiAudio(url);
    const now = Date.now();
    if (now - entry.last < UI_MIN_GAP_MS) return;
    entry.last = now;
    if (uiCurrent && uiCurrent !== entry.audio) {
      uiCurrent.pause();
    }
    const { audio } = entry;
    audio.volume = volume;
    try { audio.currentTime = 0; } catch (_) { /* henüz yüklenmedi */ }
    uiCurrent = audio;
    audio.play().catch(() => {});
  } catch (_) {
    // ignore
  }
}

/** Arayüz seslerini önceden yükler (ilk tıklamada gecikme olmasın). */
export function preloadUiSfx(paths) {
  (paths || []).forEach((p) => {
    try { uiAudio(p.startsWith('/') ? p : `/${p}`); } catch (_) { /* ignore */ }
  });
}
